export const PRICING_CATEGORY_TYPE = {
  SCHOOL_AND_ACADEMICS: 'SCHOOL_AND_ACADEMICS',
  TEAM_SPORTS_WITH_NUMBERED_JERSEY: 'TEAM_SPORTS_WITH_NUMBERED_JERSEY',
  RACING: 'RACING',
  PERFORMANCE_AND_COMPETITION: 'PERFORMANCE_AND_COMPETITION',
  OTHER: 'OTHER',
};

export const PRICING_CATEGORY_TYPE_LABELS = {
  [PRICING_CATEGORY_TYPE.SCHOOL_AND_ACADEMICS]:
    'SCHOOL & ACADEMIC (FACIAL RECOGNITION)',
  [PRICING_CATEGORY_TYPE.TEAM_SPORTS_WITH_NUMBERED_JERSEY]:
    'TEAM SPORTS (FACIAL AND/OR NUMBERED JERSEY RECOGNITION)',
  [PRICING_CATEGORY_TYPE.RACING]: 'RACING (BIB & PLATE NUMBER RECOGNITION)',
  [PRICING_CATEGORY_TYPE.PERFORMANCE_AND_COMPETITION]:
    'PERFORMANCE & COMPETITION (FACIAL REC AND/OR TIME-BASED MATCHING)',
  [PRICING_CATEGORY_TYPE.OTHER]: 'OTHER SPORTS',
};
